/**
 * Deterministic active sessionId for sandbox preview.
 * Persisted under dayone:sandbox:activeSessionId so iframe always receives a valid sessionId.
 */
const ACTIVE_SESSION_KEY = "dayone:sandbox:activeSessionId";

export function getOrCreateActiveSessionId(preferred?: string | null): string {
  if (typeof window === "undefined") return preferred && preferred.trim() ? preferred.trim() : "dev";

  const preferredTrimmed = preferred?.trim();
  if (preferredTrimmed) {
    try {
      localStorage.setItem(ACTIVE_SESSION_KEY, preferredTrimmed);
      return preferredTrimmed;
    } catch {
      return preferredTrimmed;
    }
  }

  try {
    const stored = localStorage.getItem(ACTIVE_SESSION_KEY);
    if (stored?.trim()) return stored.trim();
  } catch {
    /* ignore */
  }

  const id = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  try {
    localStorage.setItem(ACTIVE_SESSION_KEY, id);
  } catch {
    /* ignore */
  }
  return id;
}
